
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.306 1.166A1.753 1.753 0 011.956 0h1.822a1.972 1.972 0 01.981 3.684l-1.01.579A.752.752 0 013 5a.748.748 0 01-.75-.75v-.422c0-.269.144-.515.379-.65l1.384-.794a.473.473 0 00-.234-.88H1.956c-.106 0-.2.065-.234.165l-.013.037a.75.75 0 01-1.412-.5l.012-.037-.003-.003zM2 7a1 1 0 112 0 1 1 0 01-2 0z","fill":"#F05C00"}})])
          )
        }
      }
    